import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { } from "../../store/actions";
import SimpleBar from "simplebar-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftFromArc, faArrowRightFromBracket, faBars } from '@fortawesome/pro-regular-svg-icons';
import SidebarContent from "./SidebarContent";
import noProfile from '../../assets/images/users/no-profile.png';
import logoLight from '../../assets/images/logo-light.png';
import logoSmLight from '../../assets/images/logo-sm-light.png';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getUserInfo() {
        try {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            return {
                name: obj?.user?.name ?? 'Admin',
                avatar: obj?.user?.profile_image?.small?.url ?? noProfile,
            };
        } catch {
            return { name: 'Admin', avatar: noProfile };
        }
    }

    render() {
        const { name, avatar } = this.getUserInfo();
        const isCondensed = this.props.type === "condensed";

        return (
            <React.Fragment>
                <div className="vertical-menu">

                    <div className="sidebar-header">
                        <Link to="/" className="sidebar-header__logo-link">
                            <img
                                src={isCondensed ? logoSmLight : logoLight}
                                alt="Mellro"
                                className="sidebar-header__logo"
                            />
                        </Link>
                        <button
                            onClick={this.props.toggleMenuCallback}
                            className="sidebar-header__toggle"
                            title="Colapsar menu"
                        >
                            <FontAwesomeIcon icon={faBars} />
                        </button>
                    </div>

                    <div className={`sidebar-nav${isCondensed ? ' sidebar-nav--condensed' : ''}`}>
                        {!isCondensed ? (
                            <SimpleBar style={{ maxHeight: "100%", height: "100%" }}>
                                <SidebarContent />
                            </SimpleBar>
                        ) : <SidebarContent />}
                    </div>

                    <div className="sidebar-footer">
                        <img src={avatar} alt="" className="sidebar-footer__avatar" />
                        {!isCondensed && (
                            <span className="sidebar-footer__name">{name}</span>
                        )}
                        <a href="/logout" title="Logout" className="sidebar-footer__logout">
                            <FontAwesomeIcon icon={faArrowLeftFromArc} />
                        </a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout
    };
};
export default connect(mapStatetoProps, {})(withRouter(Sidebar));
